// ═══════════════════════════════════════════════════════════════════════════
// docConId — el doc como objeto, con el id del DOCUMENTO (espejo)
// ═══════════════════════════════════════════════════════════════════════════
// Espejo de functions/lib/docConId.js: el bundle del front no importa
// `functions/`, así que la regla vive dos veces, atadas por
// docConId.paridad.test.js contra una tabla dorada.
//
// `{ id: d.id, ...d.data() }` dejaba que un campo `id` guardado ADENTRO del doc
// pisara el id del documento. En `usuarios` ese campo lo escribía el navegador,
// así que la pantalla tomaba por identidad un dato plantado: el que usa la app
// podía cargar las asignaciones de otra cuenta, y «Editar usuario» operar sobre
// otra que la de la fila (tren 1 del gate de identidad, 30-sep-2026). El id va
// DESPUÉS del spread.
// ═══════════════════════════════════════════════════════════════════════════

/**
 * @param {{ id: string, data: () => object }} snap un snapshot de Firestore (que exista)
 * @returns {object} sus datos, con `id` = el id del documento
 */
export const docConId = (snap) => ({ ...snap.data(), id: snap.id })
